import { FC, useState } from "react";
import ConnectedAccount from "../../../models/ConnectedAccount";
import { Chip, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import FindingsDialog from "../common/FindingsDialog";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Loader from "../../common/Loader";
import ComplianceStatus from "../../common/ComplianceStatus";
import { useLazyQuery } from "@apollo/client";
import { GetControlDocument } from "../../../generated";

interface FTRDisruptiveProps {
  index: number;
  technicalReviewArn: string;
  row: RowQuestion;
  connectedAccounts: Array<ConnectedAccount>;
}

type FindingRow = {
  id: string;
  awsAccountId: number;
  name: string;
  complianceStatus: string;
  title: string;
  findingId: string;
  serviceID: string;
}

type RowQuestion = {
  controlname: string;
  controldescription: string;
  compliancestatus: string;
	remediatestatus: string;
  remediationestimate: string;
  remediationUrl: string;
	intrusive: string;
  controlshlink: string;
};

const FTRDisruptiveControlsRow: FC<FTRDisruptiveProps> = ({
  index,
	technicalReviewArn,
  row,
  connectedAccounts,
}: FTRDisruptiveProps) => {
  const [openFindings, setOpenFindings] = useState(false);
  /**
   * Close Findings Modal
   */
  const handleClose = () => {
    setOpenFindings(false);
  };
  const [ GetControl, { loading } ] = useLazyQuery(GetControlDocument);
    
  const [findings, setFindings] = useState<Array<FindingRow>>([]);
  /**
   * @param control sechub control
   * Get sechub control findings
   */
  const GetControlFindings = async (row: RowQuestion) => {
    const response = await GetControl({
      variables: {
        arn: technicalReviewArn,
        controlname: row.controlname,
        connectedAccounts,
      },
    });

    const findingMap = new Map();
    const findings = response.data?.getControl?.findings;
    findings.forEach((finding: any) => {
      const key = finding.Id;
      const findingId = finding.Id.match(/finding\/(.+)/);
      if (!findingMap.has(key)) {
        findingMap.set(key, {
          id: finding.Id,
          awsAccountId: finding.AwsAccountId,
          name: finding?.Resources ? finding?.Resources[0]?.Name : "",
          complianceStatus: finding.Compliance.Status,
          title: finding.Title,
          findingId: findingId[1],
          serviceID: finding?.Resources ? finding?.Resources[0]?.Id : "",
        })
      }
    });
    const data = Array.from(findingMap.values()).map(item => ({
      ...item,
    }));
    setFindings(data);
    setOpenFindings(true);
  };

  return (
    <TableRow
      key={`${row.controlname}-ftr-dc`}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        {index + 1}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.controlname}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.controldescription}
        {row.remediationestimate && (
          <Tooltip title="Remediation Estimate">
            <Chip
              label={`Manual Remediation: ${row.remediationestimate} mins`}
              size="small"
              sx={{
                backgroundColor: "gray",
                color: "white",
                ml: 0.5,
              }}
            />
          </Tooltip>
        )}
      </TableCell>
      <TableCell component="th" scope="row">
        <ComplianceStatus value={row.compliancestatus} />
      </TableCell>
      <TableCell component="th" scope="row" width={"5%"}>
        {loading ? (
          <Loader/>
        ) : (
          <IconButton color="secondary" onClick={() => GetControlFindings(row)}>
            <InfoOutlinedIcon />
          </IconButton>
        )}
        <FindingsDialog
          open={openFindings}
          handleClose={handleClose}
          control={row}
          findings={findings}
        />
      </TableCell>
    </TableRow>
  )
};

export default FTRDisruptiveControlsRow;